/**
 ShapeDiver 3D Viewer Application

 StringChecksum.js

 Content:
   Create a hash of a string

  Copyright (c) 2018 ShapeDiver GmbH

  @module StringChecksum
 */

/**
  * Create a 32bit integer checksum for a string
  * @param  {String} str [description]
  * @return {Number}   [description]
  */
var stringChecksum = function(str) {
  var hash = 0,
    strlen = str.length,
    i,
    c;
  if (strlen === 0) {
    return hash;
  }
  for (i = 0; i < strlen; i++) {
    c = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + c;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

module.exports = stringChecksum;
